import { render } from "./ListQuestions.vue?vue&type=template&id=6be158bd"
import script from "./ListQuestions.vue?vue&type=script&lang=js"
export * from "./ListQuestions.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\projetos\\ethos-plataforma-ead\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__